import { isProductInStock } from '@mango-engineering/maknet-client-sdk/lib/shop/product/util/statusUtils';
import {
  RecommendationPayload,
  RecommendationResponse,
} from '../../types/common';
import { Product } from '../../types/product.types';
import {
  getProductAvailability,
} from '../../utils/helper';
import { getProductIdWithoutPrefix } from '../../utils/product.util';
import RecommendationErrorHandler from '../Error/RecommendationErrorHandler';
import ProductService from '../product/product.service';
import RecommendationServices from '../recommendation/recommendations.service';

export async function fetchSearchCarouselRecommendations(
  payload: RecommendationPayload,
  allowAlcohol?: boolean,
  assignRecommendationData?: (rProducts: RecommendationResponse) => void,
  mmid?: string,
): Promise<RecommendationResponse> {
  const searchResponse = await RecommendationServices.getSearchProducts(
    payload?.accessToken ?? '',
    payload.searchRequest,
    allowAlcohol,
  );

  const hits = searchResponse?.hits;
  const products = hits.map(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (ele: { curated: any; document: any }) => {
      return {
        productId: ele.document.id,
        isSponsored: ele.curated,
      };
    },
  );
  const productIds = products?.map((x: { productId: string }) => x.productId);

  assignRecommendationData?.({
    products: productIds.map((id: string) => ({ id: `makro_${id}` })) as any,
    recommendationType: '',
    totalCount: searchResponse?.found ?? 0,
    actualCount: productIds?.length,
  });

  let productsData = await ProductService.getProductsByIdsV2(
    productIds,
    payload.storeCodes ?? [],
    payload?.isExpressMode,
    payload?.isSameDay,
    undefined,
    undefined,
    payload?.countryCode as any,
    undefined,
    mmid,
    payload?.afcStoreCodes,
    payload?.isAfcStoreEnabled,
    payload?.userSegments,
    payload?.isHorecaMemberEnabled,
  );

  const productsDataById = new Map(
    productsData?.map((productDetail) => [getProductIdWithoutPrefix(productDetail.id), productDetail]),
  );

  const finalProductsData: Product[] = products?.map((p: { productId: string }) => {
    const matchingProduct = productsDataById.get(p.productId);

    if (matchingProduct) {
      return {
        ...matchingProduct,
        isSponsored: matchingProduct?.isSponsored,
      };
    }
    return matchingProduct;
  });

  const actualResp = finalProductsData?.filter((p) => {
    return (
      isProductInStock(p as Product) &&
      getProductAvailability(
        p as Product,
        payload?.recommendationStoreCodes ?? payload?.storeCodes ?? [],
        undefined,
        undefined,
        undefined,
        undefined,
        payload?.hasAlcoholProductAvailability,
      ).isAvailable
    );
  });

  if (actualResp?.length !== 0)
    return {
      products: actualResp || [],
      recommendationType: '',
      totalCount: searchResponse?.found ?? 0,
    };
  else {
    return RecommendationErrorHandler.getDefaultErrorResponse();
  }
}
